export default __webpack_public_path__ + "static/Verlag-Light-a7c0b61f1dffef544e4bc6c037a6a92a.woff2";